export const zh = {
  "app.title": "survivrr.io",
  "menu.online": "在线",
  "menu.offline": "ç¦»çº¿",
  "menu.play": "开始",
  "menu.name": "名称",
  "menu.ballColor": "球颜色",
  "menu.nameColor": "名称颜色",
  "menu.moreInfo": "更多信息",
  "menu.moreInfoTitle": "更多信息",
  "menu.moreInfoSubtitle": "法律页面、Cookie 详情和联系信息。",
  "menu.back": "返回",
  "menu.privacySettings": "隐私设置",
  "menu.cookiePolicy": "Cookie 政策",
  "menu.privacyPolicy": "隐私政策",
  "menu.termsOfService": "服务条款",
  "menu.emailButton": "给我发邮件",
  "menu.websiteButton": "查看我的网站",
  "menu.contactEmailLabel": "联系邮箱：",
  "menu.emailLabel": "邮箱：",
  "menu.websiteLabel": "查看我的网站：",
  "menu.nameRequired": "请先输入名称。",
  "moreInfo.privacySettings.intro1": "你可以通过广告服务提供商在可用时显示的同意提示来管理本网站上的隐私选择。",
  "moreInfo.privacySettings.intro2": "你也可以随时在浏览器设置中控制 Cookie 和本地存储。",
  "moreInfo.privacySettings.adsHeading": "广告控制",
  "moreInfo.privacySettings.adsParagraph": "部分广告可能由 Google 或其他合作伙伴提供。个性化广告选择也可以直接在 Google 广告设置中管理。",
  "moreInfo.privacySettings.adsBullet1": "在 myadcenter.google.com 打开 Google 广告控制。",
  "moreInfo.privacySettings.adsBullet2": "如果你想重置同意选择，请清除 Cookie 或网站数据。",
  "moreInfo.privacySettings.adsBullet3": "使用浏览器隐私设置来阻止或限制 Cookie。",
  "moreInfo.privacySettings.localHeading": "本地设置",
  "moreInfo.privacySettings.localParagraph": "本游戏会保存基本的本地偏好，例如玩家名称、颜色、声音偏好和语言，以便网站在你的设备上记住它们。",
  "moreInfo.cookiePolicy.intro1": "本网站使用 Cookie 和类似存储技术来运行游戏、记住你的设置并支持广告。",
  "moreInfo.cookiePolicy.intro2": "根据你的同意选择和网站启用的服务，Cookie 也可能用于衡量、防欺诈和广告个性化。",
  "moreInfo.cookiePolicy.typesHeading": "我们可能使用的 Cookie 和存储类型",
  "moreInfo.cookiePolicy.typeBullet1": "用于保持网站正常运行的必要存储。",
  "moreInfo.cookiePolicy.typeBullet2": "用于记住你的名称、颜色、语言和声音设置的偏好存储。",
  "moreInfo.cookiePolicy.typeBullet3": "广告启用时，由 Google 等广告合作伙伴使用的广告或衡量 Cookie。",
  "moreInfo.cookiePolicy.manageHeading": "如何管理 Cookie",
  "moreInfo.cookiePolicy.manageParagraph": "你可以在可用时通过网站的同意提示管理 Cookie，或通过浏览器设置管理。禁用某些 Cookie 可能会影响网站功能或广告投放。",
  "moreInfo.privacyPolicy.intro1": "本网站是由 Michał Kierzkowski 运营的浏览器游戏。我们尽量少收集个人信息。",
  "moreInfo.privacyPolicy.intro2": "游戏不需要账户。游戏可能会在你的设备上保存基本本地偏好，并处理运行在线比赛所需的游戏数据。",
  "moreInfo.privacyPolicy.infoHeading": "我们可能处理的信息",
  "moreInfo.privacyPolicy.infoBullet1": "你选择的玩家名称和外观设置。",
  "moreInfo.privacyPolicy.infoBullet2": "运行多人功能所需的基本会话数据。",
  "moreInfo.privacyPolicy.infoBullet3": "如果启用了相关服务，分析或广告合作伙伴可能收集设备、浏览器或广告数据。",
  "moreInfo.privacyPolicy.useHeading": "我们如何使用信息",
  "moreInfo.privacyPolicy.useBullet1": "用于运行游戏和在线房间。",
  "moreInfo.privacyPolicy.useBullet2": "用于在你的设备上记住设置。",
  "moreInfo.privacyPolicy.useBullet3": "用于提高性能、安全性和稳定性。",
  "moreInfo.privacyPolicy.useBullet4": "在广告启用时用于显示广告。",
  "moreInfo.privacyPolicy.contactHeading": "联系",
  "moreInfo.privacyPolicy.contactParagraph1": "如果你有隐私相关问题，请联系：mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "网站：michalkierzkowski.com",
  "moreInfo.terms.intro1": "使用本网站即表示你同意以合法、公平的方式使用游戏。",
  "moreInfo.terms.intro2": "游戏按现状提供，可能随时更改、中断或移除。",
  "moreInfo.terms.rulesHeading": "规则",
  "moreInfo.terms.ruleBullet1": "不要滥用错误、作弊、自动化或漏洞。",
  "moreInfo.terms.ruleBullet2": "不要试图损害服务或其他玩家。",
  "moreInfo.terms.ruleBullet3": "不要使用冒犯性、违法或误导性的名称或内容。",
  "moreInfo.terms.limitationHeading": "限制",
  "moreInfo.terms.limitationParagraph": "在法律允许的最大范围内，我们不对使用本网站造成的损失、中断或损害负责。",
  "moreInfo.terms.changesHeading": "变更",
  "moreInfo.terms.changesParagraph": "这些条款未来可能会更新。更新后继续使用本网站即表示你接受更新后的条款。",
  "status.offline": "正在启动离线比赛...",
  "status.connecting": "正在连接服务器...",
  "queue.title": "正在等待房间",
  "queue.menu": "返回主菜单",
  "game.pressToMove": "按任意位置移动",
  "game.touchToMove": "触摸任意位置移动",
  "game.leaderboard": "排行榜",
  "game.hp": "生命",
  "game.level": "等级",
  "game.xp": "经验",
  "game.respawning": "正在重生...",
  "gameEnd.title": "游戏结束",
  "gameEnd.winTitle": "你赢了",
  "gameEnd.subtitle": "比赛已结束。重生以开始下一轮，或返回菜单。",
  "pause.title": "游戏菜单",
  "pause.resume": "ç»§ç»­",
  "pause.menu": "返回主菜单",
  "upgrade.title": "选择升级",
  "upgrade.generic.title": "升级",
  "upgrade.generic.description": "强化你的构筑。",
  "upgrade.newWeaponPrefix": "新武器：",
  "upgrade.stat.maxHp.title": "最大生命",
  "upgrade.stat.maxHp.description": "提高最大生命值。",
  "upgrade.stat.speed.title": "移动速度",
  "upgrade.stat.speed.description": "提高移动速度。",
  "upgrade.stat.generic.title": "属性升级",
  "upgrade.stat.generic.description": "提升你的属性。",
  "upgrade.weapon.projectileShot.title": "弹射攻击",
  "upgrade.weapon.projectileShot.description": "为你的构筑添加弹射攻击。",
  "upgrade.weapon.orbitingBalls.title": "轨道球",
  "upgrade.weapon.orbitingBalls.description": "为你的构筑添加轨道球。",
  "upgrade.weapon.damageZone.title": "伤害区域",
  "upgrade.weapon.damageZone.description": "在角色周围添加伤害区域。",
  "upgrade.weapon.generic.title": "武器",
  "upgrade.weapon.generic.description": "将此武器加入你的构筑。",
  "upgrade.weaponUpgrade.frequency.title": "频率",
  "upgrade.weaponUpgrade.frequency.description": "更频繁地攻击。",
  "upgrade.weaponUpgrade.range.title": "范围",
  "upgrade.weaponUpgrade.range.description": "增加武器范围。",
  "upgrade.weaponUpgrade.projectileCount.title": "弹射数量",
  "upgrade.weaponUpgrade.projectileCount.description": "生成更多弹射物。",
  "upgrade.weaponUpgrade.projectileSpeed.title": "弹射速度",
  "upgrade.weaponUpgrade.projectileSpeed.description": "让弹射物更快。",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "轨道速度",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "让轨道球旋转得更快。",
  "upgrade.weaponUpgrade.damage.title": "伤害",
  "upgrade.weaponUpgrade.damage.description": "造成更多伤害。",
  "upgrade.weaponUpgrade.generic.title": "武器升级",
  "upgrade.weaponUpgrade.generic.description": "强化此武器。",
  "defeat.title": "失败",
  "defeat.subtitle": "重生或返回菜单",
  "defeat.respawn": "重生",
  "defeat.menu": "主菜单",
  "error.generic": "出了点问题。",
} as const;
